import type { SharedIconProps } from '../../types/SharedIconProps';
import type {
  SegmentedControlSegment,
  SegmentedControlSegments,
} from './types';

const isSegmentSelected = (
  index: number,
  segments: SegmentedControlSegments,
  selectedKeys: ReadonlySet<string>,
): boolean =>
  index >= 0 &&
  index < segments.length &&
  selectedKeys.has(segments[index].segmentKey);

/**
 * Every segment is a full pill until two selected ones meet, where the shared
 * edge squares off so the run reads as one thumb rather than touching pills.
 */
export function getSegmentMerge(
  index: number,
  segments: SegmentedControlSegments,
  selectedKeys: ReadonlySet<string>,
): { mergeEnd: boolean; mergeStart: boolean } {
  if (!isSegmentSelected(index, segments, selectedKeys)) {
    return { mergeEnd: false, mergeStart: false };
  }

  return {
    mergeEnd: isSegmentSelected(index + 1, segments, selectedKeys),
    mergeStart: isSegmentSelected(index - 1, segments, selectedKeys),
  };
}

/**
 * An icon paired with text leads it, since the text is what the segment is read
 * by — the opposite of `Button`, where a trailing icon is the default. An icon
 * that sets its own `position` keeps it.
 */
export function resolveSegmentIcon(
  segment: SegmentedControlSegment,
): SharedIconProps | undefined {
  if (!segment.icon) return undefined;
  if (!segment.text) return segment.icon;
  return { position: 'left', ...segment.icon };
}
